import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7084/Activities";
	}
	getCampaignActivityLogs(e, t) {
		let n = this.baseUrl + "/GetCampaignActivityLogs?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetCampaignActivityLogs(e)));
	}
	processGetCampaignActivityLogs(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	assignTaskToUser(e, t) {
		let n = this.baseUrl + "/AssignTaskToUser";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processAssignTaskToUser(e)));
	}
	processAssignTaskToUser(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAutopilotTasksForCampaign(e, t, n) {
		let r = this.baseUrl + "/GetAutopilotTasksForCampaign?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		if (r += "campaignId=" + encodeURIComponent("" + e) + "&", t === null) throw new globalThis.Error("The parameter 'contractId' cannot be null.");
		t !== void 0 && (r += "contractId=" + encodeURIComponent("" + t) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAutopilotTasksForCampaign(e)));
	}
	processGetAutopilotTasksForCampaign(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getDashboardStats(e, t, n) {
		let r = this.baseUrl + "/GetDashboardStats?";
		if (e === null) throw new globalThis.Error("The parameter 'agencyIds' cannot be null.");
		if (e !== void 0 && e && e.forEach((e) => {
			r += "agencyIds=" + encodeURIComponent("" + e) + "&";
		}), t === null) throw new globalThis.Error("The parameter 'assignedToUserIds' cannot be null.");
		t !== void 0 && t && t.forEach((e) => {
			r += "assignedToUserIds=" + encodeURIComponent("" + e) + "&";
		}), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetDashboardStats(e)));
	}
	processGetDashboardStats(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	searchAllTasks(e, t) {
		let n = this.baseUrl + "/SearchAllTasks";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSearchAllTasks(e)));
	}
	processSearchAllTasks(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getTaskProgressorCampaignDetails(e, t) {
		let n = this.baseUrl + "/GetTaskProgressorCampaignDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetTaskProgressorCampaignDetails(e)));
	}
	processGetTaskProgressorCampaignDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	progressTasksWithTaskProgressor(e, t) {
		let n = this.baseUrl + "/ProgressTasksWithTaskProgressor";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processProgressTasksWithTaskProgressor(e)));
	}
	processProgressTasksWithTaskProgressor(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, j("Payload of String", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t === 409) {
			let r = e.data, i = null;
			return i = r, j("Payload of String", t, r, n, i);
		} else if (t === 500) {
			let r = e.data, i = null;
			return i = r, j("Payload of String", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	toggleTaskSteps(e, t) {
		let n = this.baseUrl + "/ToggleTaskSteps";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processToggleTaskSteps(e)));
	}
	processToggleTaskSteps(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, j("Payload of String", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return j("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	withdrawWorkflow(e, t) {
		let n = this.baseUrl + "/WithdrawWorkflow";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (M(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processWithdrawWorkflow(e)));
	}
	processWithdrawWorkflow(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data, i = null;
			return i = r, j("Payload of String", t, r, n, i);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return j("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.Listings = "Listings", e.Launch = "Launch", e.Contracts = "Contracts", e.Transactions = "Transactions", e.AdminManager = "AdminManager", e.Finance = "Finance", e.ClientServicesOperations = "ClientServicesOperations", e.Onboarding = "Onboarding", e.Executive = "Executive", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.Added = "Added", e.Created = "Created", e.Generated = "Generated", e.Obtained = "Obtained", e.Updated = "Updated", e.Completed = "Completed", e.Converted = "Converted", e.Uploaded = "Uploaded", e.SentEmail = "SentEmail", e.SentViaDocuSign = "SentViaDocuSign", e.FailedToSend = "FailedToSend", e.Archived = "Archived", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Listings = "Listings", e.Launch = "Launch", e.Contracts = "Contracts", e.Transactions = "Transactions", e.AdminManager = "AdminManager", e.Finance = "Finance", e.ClientServicesOperations = "ClientServicesOperations", e.Onboarding = "Onboarding", e.Executive = "Executive", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.Today = "Today", e.ThisWeek = "ThisWeek", e.NextWeek = "NextWeek", e.Overdue = "Overdue", e.TodayOrOverdue = "TodayOrOverdue", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.ApprovalReceivedNotConfirmed = "ApprovalReceivedNotConfirmed", e.BalanceDepositTask = "BalanceDepositTask", e.InitialDepositTask = "InitialDepositTask", e.ContractUploadedStatusDraft = "ContractUploadedStatusDraft", e.ContractDateNotSet = "ContractDateNotSet", e.CommissionShortfallConfirmation = "CommissionShortfallConfirmation", e.CommissionPlanTypeVendorChoice = "CommissionPlanTypeVendorChoice", e.LaunchDateNotSet = "LaunchDateNotSet", e.MarkedAsExchanged = "MarkedAsExchanged", e.TerminationTaskBuyerBankDetails = "TerminationTaskBuyerBankDetails", e.TerminationTaskVendorBankDetails = "TerminationTaskVendorBankDetails", e.WithdrawnTaskVendorBankDetails = "WithdrawnTaskVendorBankDetails", e.VendorBankDetailsOutstanding = "VendorBankDetailsOutstanding", e.NotMarkedAsSettled = "NotMarkedAsSettled", e.ReferralInvoiceOutstanding = "ReferralInvoiceOutstanding", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Campaign = "Campaign", e.IndependentCampaign = "IndependentCampaign", e.Contract = "Contract", e.IndependentContract = "IndependentContract", e.Deposit = "Deposit", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.AgreementDetails = "AgreementDetails", e.AgreementComplianceType = "AgreementComplianceType", e.AgreementCommission = "AgreementCommission", e.NewListing = "NewListing", e.PreLaunch = "PreLaunch", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.WithdrawnPayments = "WithdrawnPayments", e.WithdrawnPaymentsReview = "WithdrawnPaymentsReview", e.TenancyPreparationAgencyManaged = "TenancyPreparationAgencyManaged", e.TenancyPreparationSelfManaged = "TenancyPreparationSelfManaged", e.TenancyInformation = "TenancyInformation", e.SellerDisclosureAgentPreparation = "SellerDisclosureAgentPreparation", e.SellerDisclosureUpload = "SellerDisclosureUpload", e.OwnerBuilderPreparation = "OwnerBuilderPreparation", e.OwnerBuilderDeclarationUpload = "OwnerBuilderDeclarationUpload", e.HolidayRental = "HolidayRental", e.DateOfLastRentIncrease = "DateOfLastRentIncrease", e.DeceasedEstateJointTenants = "DeceasedEstateJointTenants", e.DeceasedEstateTenantsInCommon = "DeceasedEstateTenantsInCommon", e.DeceasedEstateSoleOwner = "DeceasedEstateSoleOwner", e.VendorBankDetailsWithdrawn = "VendorBankDetailsWithdrawn", e.VpaSpreadsheet = "VpaSpreadsheet", e.CampaignVendorSolicitorOutstanding = "CampaignVendorSolicitorOutstanding", e.GeneralContractCompliance = "GeneralContractCompliance", e.ContractSpecialConditions = "ContractSpecialConditions", e.ContractOffer = "ContractOffer", e.ContractParticulars = "ContractParticulars", e.ContractPreparation = "ContractPreparation", e.ContractReview = "ContractReview", e.SolicitorExchangeInformation = "SolicitorExchangeInformation", e.SolicitorExchangeContractDates = "SolicitorExchangeContractDates", e.AgentExchangeInformation = "AgentExchangeInformation", e.AgentExchangeContractDates = "AgentExchangeContractDates", e.ContractExchangeInformation = "ContractExchangeInformation", e.ContractExchangeContractDates = "ContractExchangeContractDates", e.NewContract = "NewContract", e.CoolingOffPeriod = "CoolingOffPeriod", e.FinanceDue = "FinanceDue", e.BuildingAndPestDue = "BuildingAndPestDue", e.BodyCorporateDue = "BodyCorporateDue", e.SpecialCondition = "SpecialCondition", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.SettlementPayments = "SettlementPayments", e.SettlementPaymentsReview = "SettlementPaymentsReview", e.Termination = "Termination", e.TerminationPayments = "TerminationPayments", e.TerminationPaymentsReview = "TerminationPaymentsReview", e.InitialDeposit = "InitialDeposit", e.BalanceDeposit = "BalanceDeposit", e.EarlyReleaseOfDeposit = "EarlyReleaseOfDeposit", e.DepositExceeds10Percent = "DepositExceeds10Percent", e.VendorBankDetailsSettlement = "VendorBankDetailsSettlement", e.VendorBankDetailsTermination = "VendorBankDetailsTermination", e.BuyerBankDetailsTermination = "BuyerBankDetailsTermination", e.CommissionShortfall = "CommissionShortfall", e.VendorChoiceCommission = "VendorChoiceCommission", e.ReferralAgentConjunctionInvoice = "ReferralAgentConjunctionInvoice", e.CreateBuyerContactInCrm = "CreateBuyerContactInCrm", e.DepositExceeds10PercentPaymentReview = "DepositExceeds10PercentPaymentReview", e.ContractVendorSolicitorOutstanding = "ContractVendorSolicitorOutstanding", e.ContractBuyerSolicitorOutstanding = "ContractBuyerSolicitorOutstanding", e.EarlyReleaseOfDepositPaymentReview = "EarlyReleaseOfDepositPaymentReview", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.ChangeStage = "ChangeStage", e.ReinitialiseTasksOnly = "ReinitialiseTasksOnly", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.ChangeStage = "ChangeStage", e.ReinitialiseTasksOnly = "ReinitialiseTasksOnly", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.AgreementCompliance = "AgreementCompliance", e.NewListing = "NewListing", e.Launch = "Launch", e.Withdrawn = "Withdrawn", e.IndependentCampaign = "IndependentCampaign", e.ContractCompliance = "ContractCompliance", e.ContractRequest = "ContractRequest", e.Exchange = "Exchange", e.NewContract = "NewContract", e.Conditions = "Conditions", e.Unconditional = "Unconditional", e.Settlement = "Settlement", e.BackUpContract = "BackUpContract", e.Termination = "Termination", e.IndependentContract = "IndependentContract", e.Deposits = "Deposits", e;
}({}), A = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isActivitiesApiException = !0;
	static isActivitiesApiException(e) {
		return e.isActivitiesApiException === !0;
	}
};
function j(e, t, n, r, i) {
	throw i ?? new A(e, t, n, r, null);
}
function M(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var N = "activities";
function P(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var F = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), P(r);
}, I = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[N] || `${e}/${N}`;
}, L = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = I(i), u = c, d = F(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(F(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, R = a({}), z = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = L(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(R.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, B = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getCampaignActivityLogs", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getCampaignActivityLogs(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, V = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCampaignActivityLogs", e] });
	}, e[0] = t, e[1] = n), n;
}, H = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(R), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.assignTaskToUser(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		assignTaskToUser: u,
		assignTaskToUserPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, U = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(R), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getAutopilotTasksForCampaign",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== s || i[4] !== e || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getAutopilotTasksForCampaign(e, t, r);
	}, i[3] = s, i[4] = e, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, W = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getAutopilotTasksForCampaign",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, G = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(R), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getDashboardStats",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getDashboardStats(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, K = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getDashboardStats",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(R), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.searchAllTasks(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		searchAllTasks: u,
		searchAllTasksPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, J = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(R), s;
	n[0] === e ? s = n[1] : (s = ["getTaskProgressorCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getTaskProgressorCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Y = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getTaskProgressorCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, X = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(R), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.progressTasksWithTaskProgressor(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		progressTasksWithTaskProgressor: u,
		progressTasksWithTaskProgressorPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Z = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(R), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.toggleTaskSteps(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		toggleTaskSteps: u,
		toggleTaskStepsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(R), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.withdrawWorkflow(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		withdrawWorkflow: u,
		withdrawWorkflowPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { R as ActivitiesApiContext, A as ActivitiesApiException, z as ActivitiesApiProvider, f as ActivitiesClient, N as ActivitiesRoute, p as AutopilotTaskDtoTeamType, m as IActivityLogResponseAction, v as SearchTaskRequestTaskDue, _ as Stages, h as States, y as TaskBlockerBlockerType, x as TaskCategoryStage, C as TaskCategoryState, S as TaskCategoryTaskType, b as TaskCategoryWorkflowType, w as TaskProgressorCampaignDetailsState, E as TaskProgressorRequestMode, T as TaskProgressorRequestTargetStage, O as TaskProgressorResponseMode, D as TaskProgressorResponseTargetStage, k as TaskProgressorStageOptionStage, g as TeamTypes, L as useActivitiesClientContext, H as useAssignTaskToUser, U as useGetAutopilotTasksForCampaign, B as useGetCampaignActivityLogs, G as useGetDashboardStats, J as useGetTaskProgressorCampaignDetails, W as useInvalidateUseGetAutopilotTasksForCampaign, V as useInvalidateUseGetCampaignActivityLogs, K as useInvalidateUseGetDashboardStats, Y as useInvalidateUseGetTaskProgressorCampaignDetails, X as useProgressTasksWithTaskProgressor, q as useSearchAllTasks, Z as useToggleTaskSteps, Q as useWithdrawWorkflow };
